export default "__VITE_ASSET__ClWz25gh__"